export default function shouldShowJustDroppedAndTrendingBadgeUtil (props) {
  const {
    wasJustDropped,
    trending,
    discountPrice,
    isEquinoxLoves,
    isAllures2024TopPicks,
    isBlackOwned,
    isTopDeal
  } = props

  return (
    wasJustDropped &&
    trending &&
    !discountPrice &&
    !isTopDeal &&
    !isEquinoxLoves &&
    !isAllures2024TopPicks &&
    !isBlackOwned
  )
}
